import { render, staticRenderFns } from "./xeHorizontalBarSetting.vue?vue&type=template&id=38b81f10"
import script from "./xeHorizontalBarSetting.vue?vue&type=script&lang=js"
export * from "./xeHorizontalBarSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports